import './App.css';
import { BrowserRouter, useLocation } from 'react-router-dom';
import AppRoutes from './routes';
import ScrollToTop from './pages/main_website/ScrollToTop';
import { useEffect } from 'react';

function AppWrapper() {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin') || location.pathname === '/admin-login';

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <div className="App">
      <ScrollToTop />
      {isAdminRoute ? (
        <AppRoutes />
      ) : (
        <div className="main-content">
          <AppRoutes />
        </div>
      )}
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppWrapper />
    </BrowserRouter>
  );
}

export default App;
